"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const helpers_1 = require("@freelancerepublik/helpers");
const TermsList_core_1 = require("@freelancerepublik/models-core/TermsList.core");
const FrkModal_vue_1 = __importDefault(require("@freelancerepublik/commons/ui/components/FrkModal.vue"));
const FrkFlexContainer_vue_1 = __importDefault(require("@freelancerepublik/commons/ui/components/FrkFlexContainer.vue"));
const FrkButton_vue_1 = __importDefault(require("@freelancerepublik/commons/ui/components/FrkButton.vue"));
const UserTermsModal_generated_1 = require("./UserTermsModal.generated");
exports.default = (0, vue_1.defineComponent)({
    __name: 'UserTermsModal',
    setup(__props) {
        const isLoading = (0, vue_2.ref)(false);
        const $apollo = (0, vue_2.getCurrentInstance)().proxy.$apollo;
        const $store = (0, vue_2.getCurrentInstance)().proxy.$store;
        const $modal = (0, vue_2.getCurrentInstance)().proxy.$modal;
        const termsFormattedUpdatedDate = (0, vue_2.computed)(() => helpers_1.dateUtils.formatDate(TermsList_core_1.TERMS_OF_CONTRACT_LATEST_UPDATE, 'Do MMMM YYYY'));
        async function acceptTerms() {
            isLoading.value = true;
            try {
                await $apollo.mutate({
                    mutation: UserTermsModal_generated_1.AcceptTermsDocument,
                });
                $store.dispatch('messages/pushFlashMessage', {
                    message: 'Acceptation enregistrée !',
                });
                $modal.hide();
            }
            catch (err) {
                $store.dispatch('messages/pushFlashMessage', {
                    message: err.message,
                    colorClass: 'invalid',
                });
            }
            isLoading.value = false;
        }
        return { __sfc: true, isLoading, $apollo, $store, $modal, termsFormattedUpdatedDate, acceptTerms, FrkModal: FrkModal_vue_1.default, FrkFlexContainer: FrkFlexContainer_vue_1.default, FrkButton: FrkButton_vue_1.default };
    }
});
